import { useEffect, type ReactElement } from 'react';
import { ErrorCode } from '@gr/core/errors';
import { useT } from '../../../../app/di';
import { Button } from '../../../../ui-kit/Button/Button';
import { Card } from '../../../../ui-kit/Card/Card';
import { FormAlert, FormTextField, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';

export interface Credentials {
  login: string;
  password: string;
}

export interface LoginFormProps {
  onSubmit(credentials: Credentials): Promise<ServerOutcome>;
  /** Подставить логин и пароль (выбор демо-учётки, DEMO-UC-1). */
  preset?: Credentials | null;
}

/** IAM-UC-1, IAM-UC-1.CC-1, IAM-UC-1.CC-2: вход по логину и паролю. */
export function LoginForm({ onSubmit, preset }: LoginFormProps): ReactElement {
  const { t } = useT();
  const { form, submit } = useServerForm<Credentials>({ defaultValues: { login: '', password: '' }, fields: ['login', 'password'], onSubmit });
  const { control, formState, reset } = form;
  useEffect(() => {
    if (preset) reset(preset);
  }, [preset, reset]);
  const required = { required: ErrorCode.FieldRequired };
  return (
    <Card title={t('identity.login.title')}>
      <form className="u-stack" onSubmit={submit} noValidate>
        <FormAlert form={form} />
        <FormTextField control={control} name="login" label={t('identity.login.login')} autoComplete="username" rules={required} required disabled={formState.isSubmitting} />
        <FormTextField
          control={control}
          name="password"
          label={t('identity.login.password')}
          type="password"
          autoComplete="current-password"
          rules={required}
          required
          disabled={formState.isSubmitting}
        />
        <Button type="submit" variant="primary" loading={formState.isSubmitting} block>
          {t('identity.login.submit')}
        </Button>
      </form>
    </Card>
  );
}
